import { formatNumberMagnitude } from '../helpers/stringFormat';
import { addCurrencyFrequency } from '../helpers/currencyFormat';

export const getSliderInitialValues = ({ cost_per_multiple }) => {
    const average = {};

    // Iterate over each key in cost_per_multiple object
    for (const key in cost_per_multiple) {
        if (cost_per_multiple.hasOwnProperty(key)) {
            // Calculate average for current key
            const currentCosts = cost_per_multiple[key];
            const currentAverage = (currentCosts.lower + currentCosts.higher) / 2;

            // Assign the average to the key in the result object
            average[key] = currentAverage;
        }
    }

    return average;
};

// export const getSliderInitialValue = ({ cost_per_multiple }, type) => {
//     if (cost_per_multiple.hasOwnProperty(type)) {
//         // Calculate average for type
//         const currentCosts = cost_per_multiple[type];
//         const average = (currentCosts.lower + currentCosts.higher) / 2;

//         // Determine magnitude based on the range between lower and higher
//         const range = currentCosts.higher - currentCosts.lower;

//         let roundedValue;

//         // Set rounding scale based on magnitude of the range
//         if (range >= 1000000) {
//             // Round to the nearest million
//             roundedValue = Math.round(average / 10000) * 10000;
//         } else if (range >= 100000) {
//             // Round to the nearest thousand
//             roundedValue = Math.round(average / 1000) * 1000;
//         } else if (range >= 100000) {
//             // Round to the hundred
//             roundedValue = Math.round(average / 100) * 100;
//         } else if (range >= 10000) {
//             // Round to the ten
//             roundedValue = Math.round(average / 10) * 10;
//         } else if (range >= 10) {
//             // Round to the nearest integer
//             roundedValue = parseFloat(average.toFixed(1));
//         } else {
//             // Round to 2 decimal places for smaller ranges
//             roundedValue = parseFloat(average.toFixed(2));
//         }

//         return roundedValue;


//         // return (currentCosts.lower + currentCosts.higher) / 2;
//     }
//     else {
//         return null
//     }
// };

export const getSliderInitialValue = ({ cost_per_multiple }, type) => {
    if (cost_per_multiple.hasOwnProperty(type)) {
        // Calculate average for type
        const currentCosts = cost_per_multiple[type];
        const average = (currentCosts.lower + currentCosts.higher) / 2;

        // Determine the range between lower and higher
        const range = currentCosts.higher - currentCosts.lower;

        // Determine the rounding factor based on the magnitude of the range
        const roundingFactor = Math.pow(10, Math.floor(Math.log10(range)) - 2); // Power of 100 below the range

        // Round the average to the nearest roundingFactor
        let roundedValue = Math.round(average / roundingFactor) * roundingFactor;

        // Format the rounded value to avoid floating-point issues
        const decimalPlaces = Math.max(0, -Math.floor(Math.log10(roundingFactor))); // Count decimal places based on the rounding factor
        roundedValue = parseFloat(roundedValue.toFixed(decimalPlaces));

        return roundedValue;
    } else {
        return null;
    }
};

export const getMultipleInitialValues = ({ multiple_type }, value = 0) => {
    const multiple = {};

    if (!multiple_type) {
        return null
    }

    // Iterate each key in multiple array
    multiple_type.forEach(element => {
        multiple[element] = value;
    })

    return multiple;
}

export const getNegativeDriverInitialValues = ({ multiple_type }) => {
    const negativeDriver = {};

    if (!multiple_type) {
        return null
    }

    // Iterate each key in multiple array
    multiple_type.forEach(element => {
        negativeDriver[element] = true;
    })

    return negativeDriver;
}

export const getPositiveDriverInitialValues = ({ multiple_type }) => {
    const positiveDriver = {};

    if (!multiple_type) {
        return null
    }

    // Iterate each key in multiple array
    multiple_type.forEach(element => {
        positiveDriver[element] = true;
    })

    return positiveDriver;
}

export const createSliderMarks = ({ currency, lower, higher, upper }) => {
    const upperValue = higher !== undefined ? higher : upper;

    const marks = [
        {
            value: lower,
            label: addCurrencyFrequency(formatNumberMagnitude(lower), currency, null)
        },
        {
            value: upperValue,
            label: addCurrencyFrequency(formatNumberMagnitude(upperValue), currency, null)
        }
    ];

    return marks;
};

export const getAverageValue = (values) => {
    return (values.lower + values.higher) / 2
}

export const getRatio = (costStructure, selectedType) => {
    const ratioString =
        costStructure?.cost_per_multiple?.[selectedType]?.ratio_lower;

    const ratio = parseFloat(ratioString);

    if (!isNaN(ratio)) {
        const percentage = ratio * 100;
        return ratio < 0.01 ? Math.round(percentage * 10) / 10 : Math.round(percentage);
    }

    return 0;
};